/* 🤖 this file was generated by svg-to-ts*/
export const icoPerformance: {
  name: 'performance';
  data: string;
} = {
  name: 'performance',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm0 2a8 8 0 015.6 13.713A9.954 9.954 0 0012 16a9.953 9.953 0 00-5.6 1.713A8 8 0 0112 4zm4.707 3.293a1 1 0 00-1.32-.083l-.094.083-2.776 2.775A2.003 2.003 0 0010 12a2 2 0 103.97-.35l-.038-.167 2.775-2.776.083-.094a1 1 0 00-.083-1.32z" fill="#909090"/></svg>`
};
